// extracted by mini-css-extract-plugin
module.exports = {"titleResultCerified":"result_titleResultCerified__2aSCD","buttonCertified":"result_buttonCertified__2Aj8z","buttonPending":"result_buttonPending__NEXQL"};